import template from './content-container.template.html';
import './content-container.style.scss';

const component = {
	template,
	transclude: true,
};

export default component;



// WEBPACK FOOTER //
// ./src/modules/base/components/content-container/index.js